import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import { eventCommonStore } from 'state/event/eventCommon'
import FaqModal from 'pages/Events/Views/Common/Modals/FaqModal'
import AddQuestion from 'pages/Events/Views/Common/Modals/AddQuestion'
import { leagueEventStore } from 'state/league/leagueEvent'

const Faq: React.FC = () => {
  const [faqModalOpen, setFaqModalOpen] = useState<boolean>(false)
  // const { faqModalOpen, setFaqModalOpen, addQuestionModal, selectedQuestions } =
  //   eventCommonStore(store => ({
  //     faqModalOpen: store.faqModalOpen,
  //     setFaqModalOpen: store.setFaqModalOpen,
  //     addQuestionModal: store.addQuestionModal,
  //     selectedQuestions: store.selectedQuestions,
  //   }))

  const { leagueData, selectedQuestions, setSelectedQuestions } =
    leagueEventStore(store => ({
      leagueData: store.leagueData,
      selectedQuestions: store.selectedQuestions,
      setSelectedQuestions: store.setSelectedQuestions,
    }))

  return (
    <>
      <div onClick={() => setFaqModalOpen(true)}>
        <IconsTextNavigation
          iconName="Question"
          heading="FAQ"
          isCompleted={selectedQuestions.length > 0 ? true : false}
        />
      </div>

      {faqModalOpen && (
        <FaqModal
          openModal={faqModalOpen}
          setOpenModal={setFaqModalOpen}
          organizationId={leagueData.organizationId}
          referenceId={leagueData._id}
          reference="league"
          selectedFaqs={selectedQuestions}
          setSelectedFaqs={setSelectedQuestions}
        />
      )}
    </>
  )
}

export default Faq
